export default __webpack_public_path__ + "static/media/icafe.5357a15a.svg";